import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'doubleChamili';
const args = {};

export class DoubleChamili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
